import * as React from "react";
import corporateLogo from "@/assets/corporate_logo.svg";

const CorporateLogo: React.FC<object> = () => {
  return <img src={corporateLogo} alt="Graffer" width="120" />;
};

export default CorporateLogo;
